var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-06-22
 * @brief SEI Report 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
// recoil
import { useRecoilState, useRecoilValue } from "recoil";
// utils
// datepicker
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { alertState, reportTypeState } from "@recoil/assessmentState";
import { langId } from "@recoil/langState";
import { reloadAlert, reLoadPage, reLoadState, userInfoLoginState } from "@recoil/userState";
import { useTrans } from "@utils/langs/useTrans";
import { useAsync } from "react-async";
import ReportEnergy from "./ReportEnergy";
import ReportTotal from "./ReportTotal";
import ReportTree from "./ReportTree";
import ReportView from "./ReportView";
// utils
import ReportEnable from "@components/dashBoard/report/ReportEnable";
import ReportCheckMain from "@components/dashBoard/report/result/ReportCheckMain";
import * as HTTPUTIL from "@utils/api/HttpUtil";
import * as CUTIL from "@utils/commUtils";
import * as CONST from "@utils/Const";
import { useOutletContext } from "react-router-dom";
function ReportMain() {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const langIds = useRecoilValue(langId);
    const report = useRecoilValue(reportTypeState);
    const reloadAlerts = useRecoilValue(reloadAlert);
    const [alert, setAlert] = useRecoilState(alertState);
    const [reLoadPages, setReLoadPages] = useRecoilState(reLoadPage);
    const [reloadState, setReloadState] = useRecoilState(reLoadState);
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    // width 1650 Check용
    const [is1650M, setIs1650M] = useState(false);
    //props
    const { handleOpenPop } = useOutletContext();
    const reportList = [
        { type: "enable", dept: 1, name: t("REPORT.에너지레포트"), code: 2 },
        { type: "assessment", dept: 1, name: t("REPORT.설비진단"), children: true },
        { type: "assessment", dept: 2, name: t("REPORT.LS정밀점검"), code: "LS", codeName: "LS 정밀점검" },
        { type: "assessment", dept: 2, name: t("REPORT.고객향점검"), code: "고객향", codeName: "고객향 점검" },
        { type: "energyreport", dept: 1, name: t("REPORT.에너지진단"), children: true },
        { type: "energyreport", dept: 2, name: "Basic Reports", code: 0 },
        { type: "energyreport", dept: 2, name: "Premium Reports", code: 1 },
        { type: "total", dept: 1, name: t("REPORT.종합진단") },
    ];
    const [mobileTree, setMobileTree] = useState(false);
    const [treeSel, setTreeSel] = useState(reportList[0]);
    const [work, setWork] = useState(report.smenu);
    const [basketsItem, setBasketsItem] = useState(null);
    const [success, setSuccess] = useState([]);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        if (window.innerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    // 장바구니 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/assessment/baskets`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: langIds.toString() + reloadAlerts + reloadState + reLoadPages,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                if (reLoadPages && data.body <= 0) {
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-nonreport", type: CONST.TYPE_ERROR, divTag: t("라벨.현재장바구니의목록이없습니다"), callBack: () => {
                            CUTIL.jsclose_Popup("pop-report");
                            CUTIL.jsclose_InPopup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                setBasketsItem({
                    checkAll: reLoadPages ? false : true,
                    title: reportList
                        .filter((item) => data.body.find((vas) => (vas.checkTypeName && vas.checkTypeName.includes(item.code)) ||
                        (vas.energyType !== null && vas.energyType == item.code)))
                        .map((list) => (Object.assign(Object.assign({}, list), { groupChecked: reLoadPages ? false : true, cnt: data.body
                            .filter((vas) => (vas.checkTypeName && vas.checkTypeName.includes(list.code)) ||
                            (vas.energyType !== null && vas.energyType == list.code))
                            .map((item) => item.basketId) }))),
                    content: data.body.map((list) => (Object.assign(Object.assign({}, list), { code: !list.checkTypeName
                            ? list.energyType
                            : reportList.find((value) => list.checkTypeName.includes(value.code)).code, checked: reLoadPages ? false : true }))),
                });
                // alert 후 장바구니
                var btnCommentClose = document.getElementById(CONST.POP_ALERT);
                if (!CUTIL.isnull(btnCommentClose)) {
                    if (btnCommentClose.className.indexOf("hidden") > 0 && success.length > 0) {
                        CUTIL.jsopen_AlertPopup("pop-report");
                        setSuccess([]);
                    }
                }
                setReloadState(false);
                setReLoadPages(false);
            }
        }
    }, [data, reloadState, reloadAlerts, is1650M, isMobile, langIds]);
    const mobileTreeClick = () => {
        setMobileTree(!mobileTree);
    };
    return (_jsxs(_Fragment, { children: [report.checkType == "main" && (_jsxs("main", Object.assign({ className: "container report new", style: { cursor: "default" } }, { children: [_jsx("div", Object.assign({ className: `treebar__toggleBtn ${mobileTree ? "active" : ""}`, onClick: mobileTreeClick }, { children: _jsx("p", { children: treeSel.name }) })), _jsx("section", Object.assign({ className: "content w100p" }, { children: _jsx("article", Object.assign({ className: "box" }, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsx(ReportTree, { reportList: reportList, treeSel: treeSel, setTreeSel: setTreeSel, mobileTree: mobileTree, setMobileTree: setMobileTree, setWork: setWork, work: work }), (() => {
                                        if (work == "enable") {
                                            return _jsx(ReportEnable, { handleOpenPop: handleOpenPop, isMobile: isMobile, treeSel: treeSel });
                                        }
                                        else if (work == "total") {
                                            return (_jsx(ReportTotal, { handleOpenPop: handleOpenPop, isMobile: isMobile, is1650M: is1650M, treeSel: treeSel }));
                                        }
                                        else if (work == "assessment") {
                                            return (_jsx(ReportView, { handleOpenPop: handleOpenPop, isMobile: isMobile, treeSel: treeSel, setWork: setWork, basketsItem: basketsItem, setBasketsItem: setBasketsItem, setSuccess: setSuccess }));
                                        }
                                        else {
                                            return (_jsx(ReportEnergy, { handleOpenPop: handleOpenPop, isMobile: isMobile, is1650M: is1650M, treeSel: treeSel, setWork: setWork, basketsItem: basketsItem, setBasketsItem: setBasketsItem, setSuccess: setSuccess }));
                                        }
                                    })()] })) })) }))] }))), report.checkType == "view" && _jsx(ReportCheckMain, { handleOpenPop: handleOpenPop })] }));
}
export default ReportMain;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
